import { render, staticRenderFns } from "./StockImageLibraryTab.vue?vue&type=template&id=08bf1bde"
import script from "./StockImageLibraryTab.vue?vue&type=script&lang=js"
export * from "./StockImageLibraryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports